import Vue from 'vue';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueGtm from 'vue-gtm';
import VueMeta from 'vue-meta';
import App from './App.vue';

import './assets/css/main.css';
import router from './router';

// Google Tag Manager
if (process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
    vueRouter: router,
  });
}

// Vue Meta
Vue.use(VueMeta);

// Validation Rules
extend('required', {
  ...required,
  message: 'This field is required.',
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
